// phone.jsx — the shared page header (LLHeader / PageHeader) and back button.
// (The old desktop phone bezel and static tab bar were retired with the Vite
// full-viewport layout; shell.jsx owns the live tab bar.)

import React from 'react';
import { LL } from './tokens.jsx';

// The one page header. Tab roots (back=false): 11px kicker + 34px H1.
// Sub-pages: a 40px circle back button + 28px inline title (optional kicker).
// Every variant starts at LL.pageTop so all screens share the same top line.
export function BackButton({ onClick, label = 'Back', icon, style = {} }) {
  return (
    <button type="button" aria-label={label} onClick={onClick} style={{
      width: 40, height: 40, borderRadius: LL.r.pill, flexShrink: 0,
      background: LL.surface, border: `1px solid ${LL.line}`,
      color: LL.fg, display: 'flex', alignItems: 'center', justifyContent: 'center',
      cursor: 'pointer', padding: 0, transition: `background ${LL.motion.fast}ms ${LL.ease}`, ...style,
    }}>
      {icon || (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M12.5 4.5L7 10l5.5 5.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </button>
  );
}

function LLHeader({ title, kicker, right, back = true, onBack, style = {}, titleStyle = {} }) {
  const root = !back;
  return (
    <div style={{
      padding: '0 16px 14px',
      paddingTop: LL.pageTop,
      display: 'flex', alignItems: root ? 'flex-end' : 'center', gap: 12, flexShrink: 0,
      ...style,
    }}>
      {back && <BackButton onClick={onBack} />}
      <div style={{ flex: 1, minWidth: 0 }}>
        {kicker && (
          <div style={{
            fontFamily: LL.ui, fontSize: LL.fs.cap, fontWeight: 700, color: LL.fgDim,
            letterSpacing: 1.2, textTransform: 'uppercase', marginBottom: root ? 4 : 2,
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
          }}>{kicker}</div>
        )}
        <div style={{
          fontFamily: LL.display, fontWeight: 700, fontSize: root ? LL.fs.h1 : LL.fs.h2,
          color: LL.fg, letterSpacing: root ? -0.6 : -0.4, lineHeight: 1.05,
          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', ...titleStyle,
        }}>{title}</div>
      </div>
      {right}
    </div>
  );
}
export const PageHeader = LLHeader;

export { LLHeader };
